export default __webpack_public_path__ + "static/media/c002-whatsapp-02-en.29af6735.png";